export const onKeyPress = (onEnter, onEscape) => (event) => {
    if (event.keyCode === 13) {
        onEnter(event);
    }
    if (event.keyCode === 27) {
        onEscape(event);
    }
};

export const minLengthChecker = (minLength) => (value) => {
    if (value && value.length < minLength) return `Should be a minimum of ${minLength} characters`;
    return undefined;
};

export const minValueChecker = (min) => (value) => {
    if (value < 1) return `Should be a minimum of ${min}`;
    return undefined;
};
